(function ($) {
	const arrow =
		'<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none"><circle cx="41.3438" cy="41.3438" r="30.8438" stroke="currentColor" stroke-width="3"/><path d="M33.0865 42.0003H47.7471L41.3421 48.4053C40.8302 48.9172 40.8302 49.7572 41.3421 50.2691C41.854 50.7809 42.6809 50.7809 43.1927 50.2691L51.8421 41.6197C52.354 41.1078 52.354 40.2809 51.8421 39.7691L43.2059 31.1066C42.694 30.5947 41.8671 30.5947 41.3552 31.1066C40.8434 31.6184 40.8434 32.4453 41.3552 32.9572L47.7471 39.3753H33.0865C32.3646 39.3753 31.774 39.9659 31.774 40.6878C31.774 41.4097 32.3646 42.0003 33.0865 42.0003Z" fill="currentColor"/></svg>';
	const prevArrow = `<button type="button" class="js-carousel__prev"><span class="sr-only">Previous</span>${arrow}</button>`;
	const nextArrow = `<button type="button" class="js-carousel__next"><span class="sr-only">Next</span>${arrow}</button>`;

	function getSlides($track) {
		return $track
			.children()
			.not('script, style, .js-carousel__prev, .js-carousel__next, .js-carousel__dots');
	}

	function getGap($track) {
		return parseFloat($track.css('column-gap') || $track.css('gap')) || 40;
	}

	function getTrackWidth($track) {
		const el = $track[0];
		const styles = window.getComputedStyle(el);
		const padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);

		return el.clientWidth - padding;
	}

	function getVisibleCols($track) {
		const $slides = getSlides($track);
		const first = $slides.get(0);
		if (!first) {
			return 1;
		}

		const gap = getGap($track);
		const cardWidth = first.getBoundingClientRect().width;
		if (!cardWidth) {
			return 1;
		}

		return Math.max(1, Math.round((getTrackWidth($track) + gap) / (cardWidth + gap)));
	}

	function getPageSize($track) {
		const first = getSlides($track).get(0);
		if (!first) {
			return getTrackWidth($track);
		}

		return getVisibleCols($track) * (first.getBoundingClientRect().width + getGap($track));
	}

	function getPageCount($track) {
		const total = getSlides($track).length;
		return Math.max(1, Math.ceil(total / getVisibleCols($track)));
	}

	function getCurrentPage($track) {
		const el = $track[0];
		const pageSize = getPageSize($track);
		const pages = getPageCount($track);
		const maxScroll = el.scrollWidth - el.clientWidth;

		if (!pageSize || pages <= 1 || maxScroll <= 4) {
			return 0;
		}

		if (el.scrollLeft >= maxScroll - 4) {
			return pages - 1;
		}

		return Math.round(el.scrollLeft / pageSize);
	}

	function prefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function scrollToPage($track, page) {
		const maxPage = getPageCount($track) - 1;
		const nextPage = Math.max(0, Math.min(page, maxPage));
		$track[0].scrollTo({
			left: nextPage * getPageSize($track),
			behavior: prefersReducedMotion() ? 'auto' : 'smooth',
		});
	}

	function enableDrag(track) {
		let pointerId = null;
		let startX = 0;
		let startScroll = 0;
		let dragging = false;
		let lastX = 0;
		let lastTime = 0;
		let velocity = 0;

		track.addEventListener('pointerdown', (e) => {
			if (e.pointerType === 'mouse' && e.button !== 0) {
				return;
			}

			pointerId = e.pointerId;
			startX = lastX = e.clientX;
			startScroll = track.scrollLeft;
			lastTime = Date.now();
			velocity = 0;
			dragging = false;
		});

		track.addEventListener('pointermove', (e) => {
			if (e.pointerId !== pointerId) {
				return;
			}

			const now = Date.now();
			velocity = (e.clientX - lastX) / (now - lastTime || 1);
			lastX = e.clientX;
			lastTime = now;

			const dx = e.clientX - startX;
			if (!dragging) {
				if (Math.abs(dx) < 8) {
					return;
				}
				dragging = true;
				track.classList.add('is-dragging');
				track.setPointerCapture(pointerId);
				track.dispatchEvent(new Event('carouseldrag'));
			}

			track.scrollLeft = startScroll - dx;
		});

		function endDrag(e) {
			if (e.pointerId !== pointerId) {
				return;
			}

			pointerId = null;
			track.classList.remove('is-dragging');

			if (!dragging) {
				return;
			}

			if (Math.abs(velocity) > 0.35) {
				track.scrollBy({
					left: -velocity * 180,
					behavior: prefersReducedMotion() ? 'auto' : 'smooth',
				});
			}

			track.addEventListener(
				'click',
				(clickEvent) => {
					clickEvent.preventDefault();
					clickEvent.stopPropagation();
				},
				{ capture: true, once: true },
			);
		}

		track.addEventListener('pointerup', endDrag);
		track.addEventListener('pointercancel', endDrag);
	}

	function initCarousel($track) {
		if ($track.data('js-carousel')) {
			return;
		}

		$track.data('js-carousel', true);

		let $wrapper = $track.parent('.js-carousel');

		if (!$wrapper.length) {
			const align = ['alignwide', 'alignfull', 'alignwider'].filter((className) =>
				$track.hasClass(className),
			);
			$track.wrap(`<div class="js-carousel${align.length ? ` ${align.join(' ')}` : ''}"></div>`);
			$wrapper = $track.parent();
		}

		$wrapper.append('<ul class="js-carousel__dots"></ul>');
		$wrapper.append('<p class="js-carousel__status" role="status" aria-live="polite" hidden></p>');
		$wrapper.append(prevArrow + nextArrow);

		const $prev = $wrapper.children('.js-carousel__prev');
		const $next = $wrapper.children('.js-carousel__next');
		const $dots = $wrapper.children('.js-carousel__dots');
		const $status = $wrapper.children('.js-carousel__status');
		let ignoreScrollUpdates = false;
		let settleTimer = null;
		let shownPage = 0;

		function arrowsWouldOverflow() {
			const rect = $wrapper[0].getBoundingClientRect();
			const needed = 84 + 24 + 8;

			return rect.left < needed || rect.right > window.innerWidth - needed;
		}

		function updateControls(page) {
			const el = $track[0];
			const hasOverflow = el.scrollWidth - el.clientWidth > 4;
			$wrapper.toggleClass('is-carousel-active', hasOverflow);
			$wrapper.toggleClass('is-carousel-controls-below', hasOverflow && arrowsWouldOverflow());

			if (!hasOverflow) {
				$dots.empty();
				$status.attr('hidden', true).text('');
				$wrapper.removeClass('is-carousel-compact-pager');
				return;
			}

			const pages = getPageCount($track);
			const current = typeof page === 'number' ? page : getCurrentPage($track);
			shownPage = current;

			$prev.prop('disabled', current <= 0);
			$next.prop('disabled', current >= pages - 1);

			const compact = pages > 6;
			$wrapper.toggleClass('is-carousel-compact-pager', compact);

			if (compact) {
				$dots.empty();
				$status.removeAttr('hidden').text(`${current + 1} / ${pages}`);
				return;
			}

			$status.attr('hidden', true).text('');

			if ($dots.children().length !== pages) {
				const dotsHtml = Array.from({ length: pages }, (_, i) => {
					const label = `Show page ${i + 1} of ${pages}`;
					return `<li><button type="button" aria-label="${label}">${i + 1}</button></li>`;
				}).join('');
				$dots.html(dotsHtml);
			}

			$dots.children().each(function (i) {
				$(this).toggleClass('is-active', i === current);
				$(this)
					.find('button')
					.attr('aria-current', i === current ? 'true' : null);
			});
		}

		function goToPage(page) {
			const nextPage = Math.max(0, Math.min(page, getPageCount($track) - 1));
			ignoreScrollUpdates = true;
			updateControls(nextPage);
			scrollToPage($track, nextPage);
			clearTimeout(settleTimer);
			settleTimer = setTimeout(() => {
				ignoreScrollUpdates = false;
			}, 500);
		}

		$prev.on('click', function () {
			goToPage(shownPage - 1);
		});

		$next.on('click', function () {
			goToPage(shownPage + 1);
		});

		$dots.on('click', 'button', function () {
			goToPage($(this).parent().index());
		});

		$track.on('carouseldrag', function () {
			ignoreScrollUpdates = false;
			clearTimeout(settleTimer);
		});
		$track.on(
			'scroll',
			debounce(function () {
				if (ignoreScrollUpdates) {
					return;
				}
				updateControls();
			}, 80),
		);
		$track.on('scrollend', function () {
			ignoreScrollUpdates = false;
			clearTimeout(settleTimer);
			updateControls();
		});
		$(window).on('resize', debounce(updateControls, 100));

		if (typeof ResizeObserver === 'function') {
			new ResizeObserver(debounce(updateControls, 100)).observe($track[0]);
		}

		updateControls();
		enableDrag($track[0]);
	}

	$('.is-style-carousel').each(function () {
		initCarousel($(this));
	});
})(jQuery);
